import type { TileLayer } from '@/lib/leaflet/leafletMap';

const MAPY_CZ_ATTRIBUTION =
  '<img src="https://api.mapy.cz/img/api/logo.svg" alt="Zobrazit na Mapy.cz" crossorigin="true">';

const FALLBACK_LANGUAGE = 'cs';

const MAPY_CZ_ALLOWED_LANGUAGES = [
  'cs',
  'de',
  'el',
  'en',
  'es',
  'fr',
  'it',
  'nl',
  'pl',
  'pt',
  'ru',
  'sk',
  'tr',
  'uk',
];

function sanitizeLanguage(language: string): string {
  return MAPY_CZ_ALLOWED_LANGUAGES.includes(language) ? language : FALLBACK_LANGUAGE;
}

export function mapyCzTileLayerUrl(layerId: string, language: string, apiKey: string): string {
  return `https://api.mapy.cz/v1/maptiles/${layerId}/256/{z}/{x}/{y}?apikey=${apiKey}&lang=${sanitizeLanguage(language)}`;
}

export function mapyCzLayers(
  language: string,
  mapyCzApiKey: string,
  translate: (key: string) => string,
): TileLayer[] {
  const layer = (
    id: string,
    nameKey: string,
    layerId: string,
    options?: { isDefault?: boolean; isUsedForFullZoom?: boolean },
  ): TileLayer => ({
    id,
    name: translate(nameKey),
    urlTemplate: mapyCzTileLayerUrl(layerId, language, mapyCzApiKey),
    minZoom: 0,
    maxZoom: 19,
    attribution: MAPY_CZ_ATTRIBUTION,
    isDefault: options?.isDefault ?? false,
    isUsedForFullZoom: options?.isUsedForFullZoom ?? false,
  });

  return [
    layer('mapycz-basic', 'Map_TileLayer_MapyCzBasic', 'basic'),
    layer('mapycz-aerial', 'Map_TileLayer_MapyCzAerial', 'aerial', { isUsedForFullZoom: true }),
    layer('mapycz-outdoor', 'Map_TileLayer_MapyCzOutdoor', 'outdoor', { isDefault: true }),
    layer('mapycz-winter', 'Map_TileLayer_MapyCzWinter', 'winter'),
  ];
}
